import type { Snippet } from '../types';

let fetchSnippetsPromise: Promise<Snippet[]> | null = null;
let cachedSnippets: Snippet[] | null = null;

export const withSnippetsCache = (fetcher: () => Promise<Snippet[]>): Promise<Snippet[]> => {
	if (fetchSnippetsPromise) {
		return fetchSnippetsPromise;
	}

	if (cachedSnippets !== null) {
		return Promise.resolve(cachedSnippets);
	}

	fetchSnippetsPromise = (async () => {
		try {
			const result = await fetcher();
			cachedSnippets = result;
			return result;
		} finally {
			fetchSnippetsPromise = null;
		}
	})();

	return fetchSnippetsPromise;
};

/**
 * Clear the snippets cache. This will force the next call to fetchSnippets() to make new HTTP requests.
 */
export const clearSnippetsCache = (): void => {
	cachedSnippets = null;
	fetchSnippetsPromise = null;
};
